import React, { useState } from "react";
import { DateTime } from "luxon";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import { makeStyles } from "@material-ui/core/styles";

import { CardContainer, Container } from "../../../components/Container";
import { withInstallation } from "../../../components/InstallationContext";
import { isPedestrianModeEnabled } from "../../../lib/walkupPinFeature";
import PedestrianAccessList from "./PedestrianAccessList";
import { toReportRange } from "./toReportRange";

const DEFAULT_RANGE_DAYS = 7;

const useStyles = makeStyles({
  filters: { display: "flex", alignItems: "center", flexWrap: "wrap", gap: 12 },
  date: { minWidth: 180 },
  selectButton: {
    height: 40,
    textTransform: "none",
    background: "#3127B8",
    color: "#fff",
    "&:hover": { background: "#241C8A" },
  },
});

export function PedestrianAccess({ installation, facility }) {
  const classes = useStyles();
  const zone = installation.timeZoneName;
  const today = DateTime.now().setZone(zone);
  const [startDate, setStartDate] = useState(today.minus({ days: DEFAULT_RANGE_DAYS - 1 }).toISODate());
  const [endDate, setEndDate] = useState(today.toISODate());
  const [range, setRange] = useState(null);
  const [submission, setSubmission] = useState(0);

  const handleSelect = () => {
    const selected = toReportRange(startDate, endDate, zone);
    if (selected.error) {
      alert(selected.error);
      return;
    }
    setRange(selected);
    setSubmission((count) => count + 1);
  };

  if (!isPedestrianModeEnabled(facility)) return null;

  return (
    <CardContainer>
      <Container size="large" spaceBelow="medium">
        <p>
          Each row is one pedestrian PIN entry: what the door controller did and whether Drivo found the PIN
          valid for this site. It does not show who walked through. A PIN use or a missing exit is not proof of
          misuse on its own. Times are in {zone}.
        </p>
        <Box className={classes.filters}>
          <TextField
            className={classes.date}
            size="small"
            variant="outlined"
            type="date"
            label="Start date"
            value={startDate}
            onChange={(event) => setStartDate(event.target.value)}
            InputLabelProps={{ shrink: true }}
          />
          <TextField
            className={classes.date}
            size="small"
            variant="outlined"
            type="date"
            label="End date"
            value={endDate}
            onChange={(event) => setEndDate(event.target.value)}
            InputLabelProps={{ shrink: true }}
          />
          <Button className={classes.selectButton} variant="contained" onClick={handleSelect}>Show entries</Button>
        </Box>
        {range && (
          <PedestrianAccessList
            key={submission}
            from={range.from}
            to={range.to}
            zone={zone}
            brandingKey={installation.brandingKey}
          />
        )}
      </Container>
    </CardContainer>
  );
}

export default withInstallation(PedestrianAccess);
